<template>
  <v-data-table
    :items="templates"
    :headers="headers"
    item-key="id"
    :loading="loading"
  >
    <template v-slot:item.quantity="{ item }">
      <j-decimal-input
        :value="
          orderQuantities.find(x => x.fk_order_template === item.id)
            ? orderQuantities.find(x => x.fk_order_template === item.id)
                .quantity
            : null
        "
        :suffix="''"
        :decimal="4"
        :min="0.0001"
        solo
        flat
        hide-details
        :disabled="item.is_deleted === true"
        @change="v => saveOrderQuantity(v, item)"
      ></j-decimal-input>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "OrderTemplateGrid",
  props: {
    templates: {
      type: Array,
      required: true
    },
    orderQuantities: {
      type: Array,
      required: true
    },
    store: {
      required: true
    },
    product: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getStoresAvailables"])
  },
  data() {
    return {
      headers: [
        { value: "name", text: "Nom du gabarit" },
        { value: "quantity", text: "Quantité" }
      ],
      loading: false
    };
  },
  methods: {
    async saveOrderQuantity(value, template) {
      const existing = this.orderQuantities.find(
        x => x.fk_order_template === template.id
      );
      if (existing) {
        existing.quantity = value;
        this.$emit("update", existing);
      } else {
        const data = {
          fk_product: this.product.id,
          store: this.store,
          fk_order_template: template.id,
          quantity: value
        };
        this.$emit("update", data);
      }
    }
  }
};
</script>

<style></style>
